import {Component, EventEmitter, OnInit, Optional, Output} from '@angular/core';
import { FormElementModel } from '../../../ui-kit/components/ui-form/form-element';
import { AppStore } from '../../../../stores/app-store';
import { Router } from '@angular/router';
import { GTrack } from '../../../../tracker';
import { takeUntil } from 'rxjs/operators';
import { IUser } from '../../../../interfaces';
import { SelectedWorkspaceStore } from '../../../../stores/selected-workspace.store';
import { SettingsService } from '../../../services/api/settings.service';
import { ErrorHandlerService } from '../../../services/error-handler.service';
import { BoardsApiService } from '../../../services/api/boards-api.service';
import { firstValueFrom } from 'rxjs';
import { SaveWelcomeBoardService } from '../../../services/save-welcome-board.service';
import { OnboardingService } from '../../../services/onboarding.service';
import {DialogRef} from "@angular/cdk/dialog";
import { throwError } from 'rxjs';
import { MetricService } from '../../../../core/services/metric.service';
import { UserJourneyEvent } from '../../../../core/services/user-journey.types';

export type FormValues = {
  name: string;
  phone: string;
  company: string;
  job: string;
};
@Component({
  selector: 'app-user-additional-form',
  templateUrl: './user-additional-form.component.html',
  styleUrls: ['./user-additional-form.component.less'],
})
export class UserAdditionalFormComponent implements OnInit {
  @Output() submitSuccess = new EventEmitter<void>();
  public requiredValidator = (v: any) => (!v ? 'Required' : null);
  private destroy$ = new EventEmitter<void>();

  public formState = {
    name: new FormElementModel(''),
    phone: new FormElementModel(''),
    company: new FormElementModel(''),
    job: new FormElementModel(''),
  };

  public user: IUser | null = null;

  constructor(
    private settingsService: SettingsService,
    private store: AppStore,
    private router: Router,
    private workspaceStore: SelectedWorkspaceStore,
    private errorHandler: ErrorHandlerService,
    private boardsApi: BoardsApiService,
    private saveWelcomeBoard: SaveWelcomeBoardService,
    private onboardingService: OnboardingService,
    @Optional() private dialogRef: DialogRef,
    private metricService: MetricService,
  ) {
    this.user = this.workspaceStore.getUserSync();
  }

  ngOnInit() {
    if (sessionStorage.getItem('additional-form-showed') === '1') {
      if (this.dialogRef) {
        this.dialogRef.close();
      }
    }
    this.formState = {
      name: new FormElementModel(this.user?.name || ''),
      phone: new FormElementModel(this.user?.phone || ''),
      company: new FormElementModel(this.user?.company || ''),
      job: new FormElementModel(this.user?.role || ''),
    };

    sessionStorage.setItem('additional-form-showed', '1');
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public submit(event: any) {
    const formValues = event as FormValues;
    GTrack('registration_additional-info_submit', 'registration');
    this.metricService.track({ name: UserJourneyEvent.SIGN_UP_COMPLETE });
    this.metricService.track({ name: UserJourneyEvent.FIRST_LOGIN });
    this.settingsService
      .updateUser({
        name: formValues.name,
        phone: formValues.phone,
        company: formValues.company,
        role: formValues.job,
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async (it) => {
          this.workspaceStore.setUser(it);
          if (this.saveWelcomeBoard.isWelcomeBoardElementsSaved()) {
            // TODO REG FIX
            if (!this.dialogRef) {
              this.saveWelcomeBoard
                .createWelcomeBoardElementsFromLS()
                .pipe()
                .subscribe((it) => {
                  if (it) {
                    this.router.navigate(['board', it.boardId]);
                  } else {
                    this.router.navigate(['projects']);
                  }
                });
            }

            this.onboardingService.onUserLoggedIn();
            this.submitSuccess.emit();
            if (this.dialogRef) {
              this.dialogRef.close();
            }
            return;
          }

          this.router.navigate(['/projects']);

          this.submitSuccess.emit();
          if (this.dialogRef) {
            this.dialogRef.close();
          }
        },
        (err) => {
          this.errorHandler.handleError(err);
          return throwError(() => err);
        },
      );
  }
}
